import React, { useEffect } from 'react';
import {
  Box,  
  Modal,
  Snackbar,
  TextField,
  Grid,
  Stack
} from '@mui/material';
import tagService from '../../../../services/api/insights/tagService';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import Alert from '@mui/material/Alert';
import { OutlineButton } from '../../../../resources/styling/appStyle';

const { mandy, pictonBlue } = colors;

export default function AddEditTag({
  selectedTag,
  editTagDone,
  mode,
  openEdit,
  setSelectedTag,
}) {
  const [tag, setTag] = React.useState(selectedTag);
  const [doneComplete, setDoneComplete] = React.useState(false);

  useEffect(() => {
    setTag(selectedTag);
  }, [selectedTag]);

  const handleSave = () => {
    if (mode === 'edit') {
      tagService.putTag({ ...tag, isQuestionBank: true }).then((res) => {
        setDoneComplete(false);
        setSelectedTag(res);
        editTagDone('done', res);
      });
    } else {
      tagService.postTag({ ...tag, isQuestionBank: true }).then((res) => {
        setDoneComplete(false);
        editTagDone('done', res);
      });
    }
  };

  return (
    <Modal open={openEdit} onClose={() => editTagDone('cancel')}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',          
          bgcolor: 'background.paper',
          width: 400,               
          p: 3,
        }}
      >
        <Grid container rowSpacing={1.5}>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <h2>{mode === 'edit' ? 'Edit Tag' : 'Add Tag'}</h2>        
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <TextField
              label='Tag'
              value={tag?.name}
              fullWidth
              onChange={(e) => setTag({ ...selectedTag, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <Stack direction="row" gap={1} justifyContent="flex-end">
              <OutlineButton            
                onClick={() => editTagDone('cancel')}
                sx={{ marginRight: 2 }}
              >
                Cancel
              </OutlineButton>
              <AppButton color={mandy} onClick={handleSave} sx={{ marginRight: 2 }}>
                Save
              </AppButton>
            </Stack>
          </Grid>
        </Grid>        
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={doneComplete}
          autoHideDuration={6000}
          onClose={() => setDoneComplete(false)}
          variant='filled'
        >
          <Alert severity='success' sx={{ width: '100%' }}>
            {mode === 'edit'
              ? 'Tag updated successfully!'
              : 'Tag added successfully!'}
          </Alert>
        </Snackbar>
      </Box>
    </Modal>
  );
}
